import { render, staticRenderFns } from "./SearchComplaint.vue?vue&type=template&id=2e969938&scoped=true"
import script from "./SearchComplaint.vue?vue&type=script&lang=js"
export * from "./SearchComplaint.vue?vue&type=script&lang=js"
import style1 from "./SearchComplaint.vue?vue&type=style&index=1&id=2e969938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e969938",
  null
  
)

export default component.exports